import {
    getSessionRegistrationManagerClient,
    sessionRegistrationManagerClientMockHandlers,
} from './SessionRegistrationManagerClient';

export { getSessionRegistrationManagerClient, sessionRegistrationManagerClientMockHandlers };
